import React, { useState, useEffect, useImperativeHandle, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./ReferSignUp.css";
import logoRefer from "../../../Images/logo.png"
import { ApiUrlDomain } from "../../Configration/Configrationnew";
import URLstateContext from "../../../provider/CommonContext";
import { useDispatch } from 'react-redux';
import { useCookies } from "react-cookie";
import { userSelector, clearState, setState, signupUser, forgotpassword, checkvalidotp, userupdatepassword, userupdateusername, signinemailpassword, ValidateMobile } from '../../features/User/UserSlice';
import TrackApi from "../../Activity_Track/TrackApi";
import Swal from "sweetalert2";

function ReferSignUp() {
    const [NameUser, setNameUser] = useState('');
    const [mob_no, setNewUserMobNo] = useState([]);
    const [newUserMoberror, setNewUserMoberror] = useState('');
    const [otpis1, setotpis1] = useState('');
    const [otpis2, setotpis2] = useState('');
    const [otpis3, setotpis3] = useState('');
    const [otpis4, setotpis4] = useState('');
    const [newmobotpverify, Setnewmobotpverify] = useState(false);
    const [seconds, setSeconds] = useState(30);
    const [resendDisabled, setResendDisabled] = useState(true);
    const [verifyloader, setverifyloader] = useState(false);
    const { clientId } = useContext(URLstateContext);
    const [modelshow, setShow] = useState(false);
    const handleClose = () => { setShow(false); setNewUserMobNo(''); setNewUserMoberror(''); setemailerror(''); setemail(''); Setnewmobotpverify(false) }
    const [email, setemail] = useState('');
    const [emailerror, setemailerror] = useState('');
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(['LeadId']);
    const [isGoogleLoginOpened, setisGoogleLoginOpened] = useState(true);
    const [mobile_l, setMobile_l] = useState('');
    const [showmobile, setshowmobile] = useState(false);
    const [fullOtp, setOtp] = useState("");
    const location = useLocation();
    const [referredBy, setReferredBy] = useState("");


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const ref = queryParams.get("Referred_by");

        if (ref) {
            setReferredBy(ref);
        }
    }, [location.search]);

    const loginwithemailnewflow = () => {
        if (mob_no != "" && mob_no.toString().length === 10) {
            axios.get(`${ApiUrlDomain}/otpSend?phone_no=${mob_no}`).then((res) => {
                if (res.data == 'OTP sent successfully') {
                    setotpis1('')
                    setotpis2('')
                    setotpis3('')
                    setotpis4('')
                    setisGoogleLoginOpened(false);
                    Setnewmobotpverify(true);
                    setshowmobile(false);
                    setSeconds(30);
                    setResendDisabled(true);
                }
            }).catch((error) => {
                console.log(error);
            })
        }
        else {
            setNewUserMoberror("Please enter valid mobile number");
            return false;
        }
    }
    const handleNewUserMobileNumber = event => {
        const re = /^[0-9\b]+$/;
        setMobile_l(event.target.value.length);
        if (event.target.value.length <= 10 && re.test(event.target.value)) {
            setNewUserMobNo(parseInt(event.target.value));
        }
        if (event.target.value.length == 0) {
            setNewUserMobNo("");
        }
        setNewUserMoberror("");
    };
    const NewsignFlow = () => {
        console.log("OTP entered:", fullOtp);
        if (fullOtp.length !== 4) {
            alert("Please enter valid 4-digit OTP");
            return;
        }
        setverifyloader(true);
        console.log("full otp==========", fullOtp, NameUser)
        setverifyloader(true);
        axios.get(`${ApiUrlDomain}/otpValidate?phone_no=${mob_no}&otp=${fullOtp}`).then((res) => {
            if (res.data == 'OTP validated successfully') {
                axios.post(`${ApiUrlDomain}/signupRetriveLead`, { "phone": mob_no }).then((res) => {
                    if (res && res.data.length > 0) {
                        const leadId = res.data[0].prospectID;
                        setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                        const payloadData = {
                            "RelatedProspectId": leadId,
                            "ActivityNote": "Your Activity Note",
                            "mx_Custom_1": "Home",
                            "mx_Custom_2": "Your Activity Note",
                            "mx_CustomObject_81": window.location.href
                        }

                        if (res.data[0].prospectStage == "Customer" && res.data[0].mx_Lead_Status == "Active" && res.data[0].mx_Status == "Enabled") {
                            dispatch(setState({
                                "email": mob_no,
                                "name": NameUser,
                                "ProspectStage": res.data[0].prospectStage,
                                "mx_Lead_Status": res.data[0].mx_Lead_Status,
                                "mx_Status": res.data[0].mx_Status
                            }));
                            Setnewmobotpverify(false);
                            setverifyloader(false);
                            TrackApi(payloadData);
                            setNewUserMobNo('');
                            
                        }
                        Setnewmobotpverify(false);
                        let redirecturlsignup = document.createElement('a');
                        //redirecturlsignup.href = "https://kyc.moneysukh.com";
                        redirecturlsignup.href = "https://kyc.moneysukh.com/email";
                        redirecturlsignup.target = '_blank';
                        redirecturlsignup.style.display = 'none';
                        document.body.appendChild(redirecturlsignup);
                        redirecturlsignup.click();
                        document.body.removeChild(redirecturlsignup);
                        TrackApi(payloadData);
                        setverifyloader(false);
                       
                    }
                    else {
                        let bodydataleadapi = [
                            {
                                "Attribute": "EmailAddress",
                                "Value": email
                            }, {
                                "Attribute": "Phone",
                                "Value": mob_no
                            }, {
                                "Attribute": "mx_Primary_Email_ID",
                                "Value": email
                            }, {
                                "Attribute": "SearchBy",
                                "Value": "mx_Primary_Email_ID"
                            }, {
                                "Attribute": "Source",
                                "Value": "Website"
                            }, {
                                "Attribute": "FirstName",
                                "Value": NameUser
                            },
                            {
                                "Attribute": "mx_Vendor_Unique_Id",
                                "Value": "",
                            },
                            {
                                "Attribute": "mx_website_URL_React",
                                "Value": window.location.href
                            },
                            {
                                "Attribute": "mx1_Referred_by",
                                "Value": referredBy
                            }
                        ];
                        axios.post(`${ApiUrlDomain}/signupCreateLead`, bodydataleadapi).then(async (responelead) => {
                            console.log("uhhhhhh", responelead);
                            const leadId = responelead && responelead.data && responelead.data.leadId;
                            setCookie('RelatedProspectId', leadId, { path: '/', "maxAge": 2592000 * 3 });
                            const payloadData = {
                                "RelatedProspectId": leadId,
                                "ActivityNote": "Your Activity Note",
                                "mx_Custom_1": "Home",
                                "mx_Custom_2": "Your Activity Note",
                                "mx_CustomObject_81": window.location.href
                            }
                            TrackApi(payloadData);
                            let redirecturlsignup = document.createElement('a');
                            //redirecturlsignup.href = "https://kyc.moneysukh.com";
                            redirecturlsignup.href = "https://kyc.moneysukh.com/email";
                            redirecturlsignup.target = '_blank';
                            redirecturlsignup.style.display = 'none';
                            document.body.appendChild(redirecturlsignup);
                            redirecturlsignup.click();
                            document.body.removeChild(redirecturlsignup);
                        }).catch((error) => {
                            setverifyloader(false);
                        })
                    }
                }).catch((error) => {
                    console.log(error);
                    setverifyloader(false);
                })
            } else if (res.data == 'Invalid OTP') {
                Swal.fire(`Invalid OTP Please Enter Correct Otp`);
                setverifyloader(false);
            }
        }).catch((error) => {
            setverifyloader(false);
            console.log(error);
        })
    }
    return (
        <>
            <div class="main-container">
                <div class="page-wrapper">
                    <div class="main-info">
                        <div class="left-info">
                            <div class="logo">
                                <a href="#">
                                    <img src={logoRefer} />
                                </a>
                            </div> 
                            <br></br>
                            <div class="form-flex">
                                <form>
                                    <div class="form-feild">
                                        <div class="lable-bl">
                                            <label for="phone">UserName</label>
                                        </div>
                                        <input type="text" class="input-style" placeholder="Enter UserName" onChange={(e) => setNameUser(e.target.value)} id="name" />

                                    </div>

                                    <div class="form-feild">
                                        <div class="lable-bl">
                                            <label for="phone">Phone Number</label>
                                        </div>
                                        <input type="text" class="input-style" placeholder="Enter Your Mobile Number" name="mob_no" onChange={handleNewUserMobileNumber} value={mob_no} max={10} autoComplete="off" />
                                    </div>

                                    <div class={`inputctaopt_grid ${newmobotpverify == false ? 'd-none' : ''}`}>
                                        <div class="form-feild otp-relative">
                                            <div class="lable-bl">
                                                <label for="otp">Enter OTP</label>
                                            </div>
                                            <input type="text" className="input-style" id="otp" value={fullOtp} onChange={(e) => setOtp(e.target.value)} maxLength={4} />

                                        </div>
                                    </div>
                                    <div class="form-group">
                                        {newmobotpverify == true ? verifyloader == true ? <button type="button" class="btn btn-primary w-100">Wait..</button> : <button type="button" class="btn btn-primary w-100" onClick={(e) => NewsignFlow(e)}>Verify</button> : <button type="button" class="btn btn-primary w-100" onClick={() => loginwithemailnewflow()}>Continue</button>}
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="right-info"></div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default ReferSignUp;